import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ page, pages, onChange, position = "bottom" }) {
    if (pages <= 1) return null;
    const go = (n) => {
        onChange(n);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const start = Math.max(0, page - 3);
    const nums = Array.from({ length: pages }).slice(start, Math.max(5, page + 2)).map((_, i) => start + i + 1);
    const tid = position === "top" ? "pagination-top" : "pagination";
    const p = position === "top" ? "page-top" : "page";
    return (
        <div className={`${position === "top" ? "mb-4" : "mt-8"} flex items-center justify-center gap-1`} data-testid={tid}>
            <button disabled={page <= 1} onClick={() => go(page - 1)} className="btn-outline !px-3 !py-2" data-testid={`${p}-prev`}>
                <ChevronLeft className="w-4 h-4" />
            </button>
            {nums.filter((n) => n <= pages).map((n) => (
                <button
                    key={n}
                    onClick={() => go(n)}
                    className={`w-10 h-10 rounded-full font-mono text-sm transition-all active:scale-95 ${n === page ? "bg-[hsl(var(--primary))] text-white shadow-[0_6px_16px_-6px_hsl(var(--primary)/0.8)]" : "bg-white border border-slate-200 hover:border-[hsl(var(--primary))] hover:text-[hsl(var(--primary))]"}`}
                    data-testid={`${p}-${n}`}
                >
                    {n}
                </button>
            ))}
            <button disabled={page >= pages} onClick={() => go(page + 1)} className="btn-outline !px-3 !py-2" data-testid={`${p}-next`}>
                <ChevronRight className="w-4 h-4" />
            </button>
        </div>
    );
}
